import { Link } from 'react-router-dom'

export default function NotFound() {
  return (
    <div className="min-h-[70vh] flex items-center justify-center bg-white px-4 py-16">
      <div className="text-center max-w-md space-y-6">
        <div className="inline-flex items-center justify-center bg-brand-orange/10 text-brand-orange h-20 w-20 rounded-full text-4xl mb-2">
          <i className="fa-solid fa-triangle-exclamation"></i>
        </div>
        <div className="space-y-2">
          <h1 className="text-4xl font-extrabold text-brand-dark tracking-tight">404 - Siden blev ikke fundet</h1>
          <p className="text-slate-600 text-sm leading-relaxed">
            Beklager, men den side du leder efter findes ikke. Måske er den blevet flyttet, slettet eller er i øjeblikket under ombygning.
          </p>
        </div>
        <div className="pt-4 flex flex-col sm:flex-row justify-center gap-3">
          <Link
            to="/"
            className="bg-brand-orange hover:bg-brand-orange-hover text-white font-bold py-3 px-6 rounded-lg transition-colors shadow-sm text-sm flex items-center justify-center gap-2 cursor-pointer"
          >
            <i className="fa-solid fa-house"></i>
            Gå til forsiden
          </Link>
          <Link
            to="/kontakt"
            className="border border-slate-300 hover:border-slate-400 text-slate-700 font-bold py-3 px-6 rounded-lg transition-colors text-sm flex items-center justify-center gap-2 cursor-pointer"
          >
            <i className="fa-solid fa-envelope"></i>
            Kontakt os
          </Link>
        </div>
      </div>
    </div>
  )
}
